import { Input, type InputProps } from '@breetometer/components';
import { SearchIcon } from 'BreetAssets';

const SearchInput = ({ label, ...rest }: Omit<InputProps, 'label' | 'id'> & { label?: string; id?: string }) => (
	<div className='searchinput'>
		<SearchIcon
			variant='input-search'
			className='searchinput_icon'
		/>
		<Input
			{...rest}
			label={label ?? ''}
			type='search'
			id={rest.id ?? ''}
		/>
	</div>
);

export default SearchInput;
